import { allergiesField, GynAllergiesData } from '@hb/shared'
import { useUpdateDoc } from '@hooks/backend/useUpdateDoc'
import { useCallback } from 'react'
import { useProfile } from '../../contexts/user/ProfileContext'
import { GenericEditModal } from '../DataView/GenericEditModal'

export const PatientAllergiesModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  const { user, patientRef } = useProfile()

  const update = useUpdateDoc('allergies')

  const onSubmit = useCallback(
    async (data: GynAllergiesData) => {
      if (!patientRef) return { error: 'Patient not found' }
      return update(patientRef, 'gyn.corrections.allergies', data)
    },
    [update, patientRef],
  )

  return (
    <GenericEditModal
      field={allergiesField}
      data={user?.gyn?.mergedData?.allergies}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
